export const calculateDataRanges = (properties) => {

  const ranges = properties.reduce((acc, property) => {
    // Floor - check both old and new structure
    const floorNumber = property.floor?.levelNumber ?? property.location?.floor;
    if (floorNumber !== undefined && floorNumber !== null) {
      acc.floor.min = Math.min(acc.floor.min, floorNumber);
      acc.floor.max = Math.max(acc.floor.max, floorNumber);
    }

    // Rooms
    const rooms = property.specifications?.rooms?.total;
    if (rooms !== undefined && rooms !== null) {
      acc.rooms.min = Math.min(acc.rooms.min, rooms);
      acc.rooms.max = Math.max(acc.rooms.max, rooms);
    }

    // Price
    const price = property.pricing?.totalPrice?.value;
    if (price !== undefined && price !== null && price > 0) {
      acc.price.min = Math.min(acc.price.min, price);
      acc.price.max = Math.max(acc.price.max, price);
    }

    // Area
    const area = property.specifications?.area?.total;
    if (area !== undefined && area !== null && area > 0) {
      acc.area.min = Math.min(acc.area.min, area);
      acc.area.max = Math.max(acc.area.max, area);
    }

    return acc;
  }, {
    floor: { min: Infinity, max: -Infinity },
    rooms: { min: Infinity, max: -Infinity },
    price: { min: Infinity, max: -Infinity },
    area: { min: Infinity, max: -Infinity }
  });

  // Clean up infinity values
  Object.keys(ranges).forEach(key => {
    if (ranges[key].min === Infinity) ranges[key].min = 0;
    if (ranges[key].max === -Infinity) ranges[key].max = 0;
    
    // Ensure min is not greater than max
    if (ranges[key].min > ranges[key].max) {
      ranges[key].max = ranges[key].min;
    }
  });

  // Round price values to nice numbers
  if (ranges.price.min > 0) {
    ranges.price.min = Math.floor(ranges.price.min / 1000) * 1000;
  }
  if (ranges.price.max > 0) {
    ranges.price.max = Math.ceil(ranges.price.max / 1000) * 1000;
  }

  // Keep area values with decimals - no rounding
  // if (ranges.area.min > 0) {
  //   ranges.area.min = Math.floor(ranges.area.min);
  // }
  // if (ranges.area.max > 0) {
  //   ranges.area.max = Math.ceil(ranges.area.max);
  // }

  return ranges;
};

export const getPropertyTypes = (properties) => {
  const types = new Set();
  properties.forEach(property => {
    if (property.propertyType) {
      types.add(property.propertyType);
    }
  });
  return Array.from(types);
};